function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrainMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "6.558 30.049 125.43 127.624",
    xmlns: "http://www.w3.org/2000/svg",
    height: 28,
    width: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(0, 49, 115)"
    },
    d: "M 9.247 136.001 C 5.259 134.307 6.945 128.345 6.748 124.34 C 6.534 119.963 30.423 73.984 42.062 66.957 L 96.468 31.721 C 112.638 24.906 131.52 40.424 131.988 51.371 C 131.659 51.203 131.77 83.408 131.183 84.19 C 130.959 84.49 128.118 95.186 124.581 97.728 C 114.481 104.988 93.804 120.242 75.358 132.891 C 73.652 134.061 71.965 135.208 70.308 136.325 C 68.066 137.836 65.876 139.29 63.766 140.668 C 59.757 143.286 56.033 145.626 52.762 147.546 C 46.951 150.958 35.003 151.578 33.431 151.551 C 29.005 151.909 8.808 136.037 9.247 136.001 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(145, 197, 237)"
    },
    d: "M 25.773 86.947 L 52.343 101.093 C 52.294 101.055 56.16 102.894 58.993 101.813 C 62.857 100.339 70.73 94.21 74.972 91.699 C 76.149 91.004 77.262 90.579 77.848 91.962 C 78.607 93.466 78.229 98.78 78.057 101.637 C 77.942 103.558 77.243 103.284 76.307 104.479 L 59.008 116.028 C 55.01 118.321 54.668 118.663 49.394 117.249 L 17.638 100.644 C 17.529 100.576 25.49 86.674 25.773 86.947 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.775 132.569 C 10.481 132.328 10.192 131.111 10.386 130.161 C 10.581 129.212 11.425 128.349 12.642 128.494 C 13.767 128.863 14.255 129.349 14.083 130.68 C 13.91 132.017 12.905 132.781 11.775 132.569 Z",
    style: {
      fill: "rgb(145, 197, 237)"
    },
    transform: "matrix(-1, 0, 0, -1, 24.447888, 261.082077)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 31.993 144.578 C 30.699 144.336 30.41 143.119 30.604 142.17 C 30.799 141.22 31.643 140.357 32.86 140.502 C 33.985 140.872 34.473 141.357 34.301 142.689 C 34.129 144.025 33.123 144.789 31.993 144.578 Z",
    style: {
      fill: "rgb(145, 197, 237)"
    },
    transform: "matrix(-1, 0, 0, -1, 64.883886, 285.09877)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 123.484 58.254 L 83.697 86.414 C 82.491 87.141 82.254 87.51 82.254 88.919 L 82.305 97.238 C 82.313 98.6 83.706 99.021 84.885 98.34 L 124.401 69.935 C 125.699 69.104 125.578 68.351 125.579 66.81 L 125.542 59.819 C 125.548 58.562 123.508 58.24 123.484 58.254 Z",
    style: {
      fill: "#91c5ed"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(0, 49, 115)"
    },
    cx: 264.408,
    cy: 155.737,
    rx: 6.779,
    ry: 4.761,
    transform: "matrix(0.82357, -0.567214, 0.567214, 0.82357, -237.056335, 157.141411)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(0, 49, 115)"
    },
    cx: 264.408,
    cy: 155.737,
    rx: 6.779,
    ry: 4.761,
    transform: "matrix(0.82357, -0.567214, 0.567214, 0.82357, -222.517197, 146.885109)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(0, 49, 115)"
    },
    cx: 264.408,
    cy: 155.737,
    rx: 6.779,
    ry: 4.761,
    transform: "matrix(0.82357, -0.567214, 0.567214, 0.82357, -207.974747, 136.688042)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(0, 49, 115)"
    },
    cx: 264.408,
    cy: 155.737,
    rx: 6.779,
    ry: 4.761,
    transform: "matrix(0.82357, -0.567214, 0.567214, 0.82357, -193.559876, 126.367477)"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgb(0, 49, 115)",
      stroke: "rgb(0, 49, 115)",
      strokeWidth: 2
    },
    x1: 47.787,
    y1: 157.673,
    x2: 129.206,
    y2: 99.443
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainMap);
export default __webpack_public_path__ + "static/media/train_map.254db78f.svg";
export { ForwardRef as ReactComponent };